import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let maskScene: any = null;
export default function V() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        const resizeAni = () => {
            if (maskScene) AniContainer.removeScene(maskScene);

            const clientH = (window.innerHeight || 0) * 0.2;
            const startH = Math.min(clientH, 150);
            maskScene = AniContainer.create({
                triggerElement: '.dpu-detail-V',
                triggerHook: 1,
                offset: startH,
                duration: 200, //window.innerHeight * 2,
                onEnter: () => {
                    setTextEnter(true);
                },
                //onLeave: () => setTextEnter(false),
            });
        };
        resizeAni();
    }, []);

    return (
        <section className={`dpu-detail-V dpu-detail-section  ${textEnter ? 'textEnter' : ''} ${css['dpu-detail-V']}`}>
            <h2 className="title">{t('secV_title')}</h2>
            <div className="sec1 section">
                <p className="sec-title">{t('secV_box1_title')}</p>
                <div className="box-wrapper">
                    <div className="big-box box">
                        <p className="text">{t('secV_box1_text1')}</p>
                        <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_1_1.png'} alt={t('secV_box1_text1')} />
                    </div>
                    <div className="boxs">
                        <div className="box">
                            <p className="text">{t('secV_box1_text2')}</p>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_1_2.png'} alt={t('secV_box1_text2')} />
                        </div>
                        <div className="box">
                            <p className="text">{t('secV_box1_text3')}</p>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_1_3.png'} alt={t('secV_box1_text3')} />
                        </div>
                        <div className="box">
                            <p className="text">{t('secV_box1_text4')}</p>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_1_4.png'} alt={t('secV_box1_text4')} />
                        </div>
                        <div className="box">
                            <p className="text">{t('secV_box1_text5')}</p>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_1_5.png'} alt={t('secV_box1_text5')} />
                        </div>
                        <div className="box">
                            <p className="text">{t('secV_box1_text6')}</p>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_1_6.png'} alt={t('secV_box1_text6')} />
                        </div>
                        <div className="box">
                            <p className="text">{t('secV_box1_text7')}</p>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_1_7.png'} alt={t('secV_box1_text7')} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="sec2 section">
                <p className="sec-title">{t('secV_box2_title')}</p>
                <div className="box-wrapper">
                    <div className="big-box box">
                        <p className="text">{t('secV_box2_text1')}</p>
                        <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_2_1.png'} alt={t('secV_box2_text1')} />
                    </div>
                    <div className="boxs">
                        <div className="box">
                            <p className="text">{t('secV_box2_text2')}</p>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_2_2.png'} alt={t('secV_box2_text2')} />
                        </div>
                        <div className="box">
                            <p className="text">{t('secV_box2_text3')}</p>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/launch/22_2_3.png'} alt={t('secV_box2_text3')} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
